// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import WebHeader from '@/components/web/header'
import WebFooter from '@/components/web/footer'
import WebLoading from '@/components/web/loading'
import './assets/css/web.css'
// 全局引入global
import global from "@/utils/global"

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.prototype.global = global
Vue.use(ElementUI)
Vue.component('WebHeader', WebHeader)
Vue.component('WebFooter', WebFooter)
Vue.component('WebLoading', WebLoading)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js